import React from 'react';
import "./styles.sass";
import moment from "moment";
//@ts-ignore
import { LocalizationContext } from "react-localize";
import ReservationService from 'Services/reservation.service';
import { BookResortResult, Term } from 'Interfaces/BookResort';
// @ts-ignore
import sessionStorage from 'store/storages/sessionStorage';
import { MvPrimaryBtn } from 'Generic/MvPrimaryBtn';
import BookingInfo from 'Components/Pages/ApplyYourPoints/BookingInfo';
import BookingInfoExists from 'Components/Pages/ApplyYourPoints/BookingInfoExists';
import StayPreferences from '../StayPreferences';
import GuestProfile from '../GuestProfile';
import { SelectedPreferences } from '../Review/Review';
import { ContractUsage, Preferences, ReservationDetails, WaitListReservationDetails, WaitlistRooms, WaitlistSummaryResponse } from 'Interfaces/AYPResultInterface';
import { MvTermsConditions } from 'Generic/MvTermsConditions';
import { ContractToolTip } from 'Interfaces/ContractToolTipInterface';
import { UsageDetails } from '../UsageDetails/UsageDetails';
import { AdditionalGuestProfile } from '../AdditionalGuestProfile';
import { GuestDetail, GuestEmail } from '../AdditionalGuestProfile/AdditionalGuestProfile';
import MvLink from 'Generic/MvLink';
import MvIcon from 'Generic/MvIcon';
import { MvConfirmationModal } from 'Generic/MvConfirmationModal/MvConfirmationModal';
import { PromoSection } from 'Generic/PromoSection';
import { GetAdsResponse } from 'Interfaces/AdsInterface';
import {ReactAppMode} from "../../../../Interfaces/ReactAppModes";
import {EXEC_MODE} from "../../../../cfg";
import {ScreenType} from "../../../../Constants";
import { PrimaryGuest, WaitlistCreateResultData, Summary } from 'Interfaces/CreateWaitlist';
import WaitlistCriteria from '../WaitlistCriteria';
import { logAnalyticData, trackAnalyticData } from 'Utils/analytics';
import { convertAlpha3ToAlpha2, getLanguagePreference, getStoredCorrelation, getStoredCountry, getStoredEmail, getStoredFirstName, getStoredLastName, getStoredScreenType } from 'Components/rokt/HelperMethods';
import { showPlacement, terminateRokt } from 'Components/rokt/RoktLauncherContext';
import { getAlternateSearchValue } from 'Utils/AlternateSearchValue';
import { cleanupLastReservationSession } from 'Utils/CleanupReservationSession';

interface Props {
    bookingInfo: BookResortResult;
    waitlistBookingInfo?: WaitlistCreateResultData;
    waitlistResevrationId?: number; 
    waitlistRooms?: WaitlistRooms[];
    setScreenType(screenType: ScreenType): void;
    appliedPointContracts: ContractUsage[]|null;
    contractToolTips: ContractToolTip[];
    handleContractsSort: (sortedContracts: ContractUsage[]) => void;
    screenType?: string;
    apiTimeout: string;
};

interface State {
    selectedPreferences: SelectedPreferences;
    showTwoOhTwoModal: boolean;
    ads: GetAdsResponse;
  isAlternateSearchAvailable: boolean;
};

const InitState: State = {
    showTwoOhTwoModal: false,
    selectedPreferences: {
        roomRequests: {},
        additionalRequests: '',
    },
    ads: [],
  isAlternateSearchAvailable: false,
}

class Confirmation extends React.Component<Props, State> {
    reservationService: ReservationService;
    _isMounted: boolean;
     selection: any;

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = Object.assign({}, InitState);
        this.reservationService = new ReservationService();
        this._isMounted = false;

        /**
         * PWAS Analytics on Succesful Booking and On Load
         * of confirmation Page
         */
        setTimeout(() => {
            const bookedData = JSON.parse(sessionStorage.read(ReservationService.BOOKED_RESERVATION));
            logAnalyticData({ event: 'Confirmation', siteSection: 'Points Reservation', pageName:'Booking Confirmation', website:'' }, {
                ownerActivity: 'Points Reservation',
                step:'Step 6: Confirmation',
                resortID:bookedData.summary.reservationDetails.resortId,
                resortName:bookedData.summary.reservationDetails.resortName,
                selectedDestination:bookedData.summary.reservationDetails.resortLocation,
                selectedCheckIn:bookedData.summary.reservationDetails.checkInDate,
                selectedCheckOut:bookedData.summary.reservationDetails.checkOutDate,
                selectedLengthOfStay:"",
                selectedNumberOfNights:bookedData.summary.reservationDetails.numOfNights,
                selectedGuestQuantity:bookedData.summary.reservationDetails.numOfGuests,
                vacationPointsUsed:bookedData.summary.reservationDetails.pointsRequired,
                typeOfSearch:"",
                bookingWindow:"",
                errorMessage:"",
                notificationType: "",  
                alternativeSearchResorts:  this.state.isAlternateSearchAvailable ?"yes":"no" 
            })
            trackAnalyticData('points:step6');
        }, 100);
        
    }
    initializeRoktPlacement() {
        
         const attributes={
            email: getStoredEmail(),
            firstname: getStoredFirstName(),
            lastname: getStoredLastName(),
            confirmationref:this.props.bookingInfo.reservationConfirmationNumber||"",
            country: convertAlpha3ToAlpha2(getStoredCountry()||""),
            language: getLanguagePreference(),
        }
         const isSummaryReview = ScreenType.SUMMARY_REVIEW === getStoredScreenType();
       const correlation = getStoredCorrelation();
       const hasSearchResorts = correlation && correlation.includes(ScreenType.SEARCH_RESORTS);
        if(isSummaryReview||hasSearchResorts){
                 //rokt
   
        showPlacement(attributes)
      .then((selection) => {
         this.selection=selection
      })
      .catch((error) => {
        console.error("ROKT placement failed", error);
      });
            
        }
    }

    componentDidMount() {
        this._isMounted = true;
         //rokt integration
          this.initializeRoktPlacement();
       
        const { preferences } = this.props.bookingInfo.summary; 
        // check for selected preferences in session
        let selectedPreferences = JSON.parse(sessionStorage.read(ReservationService.SELECTED_PREFERENCES));

        // if no selected preferences in session, set empty preferences with default selections
        if (!selectedPreferences) {
            selectedPreferences = {...this.state.selectedPreferences};

            (preferences as Preferences).map(preference => {
                preference.options.map(option => {
                    if (option.default) {
                        selectedPreferences = {
                            ...selectedPreferences,
                            roomRequests: {
                                ...selectedPreferences.roomRequests,
                                [preference.code]: option.code,
                            },
                        };
                    }
                })
            });

            this.reservationService.getAds().then(ads => {
                this.setState({ ads });
            });
        }

        const newState = { ...this.state, selectedPreferences,isAlternateSearchAvailable: getAlternateSearchValue(),
    };

        if (this.props.bookingInfo.twoOhTwoBookingError) {
            newState.showTwoOhTwoModal = true;
        }

        this.setState(newState);
       
    }
    
    componentWillUnmount(): void {
        this._isMounted = false;
         if (this.selection) {
            this.selection.close();
        }
        // Clear session storage related to current booking
        cleanupLastReservationSession();

        terminateRokt();
    }

    termFilter = (term: Term): boolean => {
        // don't show email term if no emails are entered that are valid
        if (this.props.bookingInfo.additionalEmails.length === 0) {
            return term.type !== 'terms-additional-emails'
        }

        return true;
    };

    handleOwnershipSummaryClick = () => {
        cleanupLastReservationSession();
        if([ReactAppMode.VCAP].includes(EXEC_MODE)) {
            window.open(`/checkpoints.jsp`, '_self');
        }else {
            window.open(`/timeshare/mvco/getProductSummary`, '_self');
        }
    }

    handleReservationActivityClick = () => {
        if([ReactAppMode.VCAP].includes(EXEC_MODE)) {
            cleanupLastReservationSession();
            window.open(`/reservationActivity.jsp`, '_self');
        }else {
            this.props.setScreenType(ScreenType.RESERVATIONS);
        }
    }

    handleBookYourHolidayClick = () => {
        if([ReactAppMode.VCAP].includes(EXEC_MODE)) {
            cleanupLastReservationSession();
            window.open(`/start_booking.do`, '_self');
        }else {
            this.props.setScreenType(ScreenType.SEARCH_RESORTS);
        }
    }

    handleReturnToSearchClick = () => {
        sessionStorage.remove(ReservationService.BOOKED_RESERVATION);
        this.props.setScreenType(ScreenType.RESERVATIONS);
    }

    toggleTwoOhTwoModal = () => {
        this.setState({showTwoOhTwoModal: !this.state.showTwoOhTwoModal});
    }

    print = () => {
        window.print();
    };

    getPrimaryGuestInformation = () => {
        const { bookingInfo } = this.props;
        const detail = bookingInfo.summary.primaryGuest
        return { ...detail, address: { ...detail }, phone: detail.phoneNumber, memberships: [{ membershipId: detail.bonvoyNumber }]  };
    }

    getPreferences(waitlistBookingInfo?: WaitlistCreateResultData) {
        return waitlistBookingInfo ? waitlistBookingInfo.summary.preferences : {} as Preferences;
    }

    getAdditionalGuests() : GuestDetail[] {
        return this.props.bookingInfo.additionalGuests.filter(x => !!x.firstName);
    }

    getAdditionalEmails(): GuestEmail[] {
        return this.props.bookingInfo.additionalEmails.filter(x => !!x).map(x => ({ email: x } as GuestEmail));
    }

    getTerms(): Term[] {
        return this.props.bookingInfo.summary.terms.filter(term => this.termFilter(term));
    }

    render() {
        const { localize } = this.context;
        const { bookingInfo, screenType} = this.props;

        const preferences: Preferences = bookingInfo.summary.preferences;

        return (
            <div className='summary-confirmation'>
                <div id="rokt-placeholder"></div>
                <MvConfirmationModal
                    header = ""
                    description = {localize("static.content.confirmation-twoohtwo-heading")}
                    message = {localize("static.content.confirmation-twoohtwo-body")}
                    confirmLabel = {localize("static.content.confirmation-twoohtwo-confirmbtn")}
                    openModal={this.state.showTwoOhTwoModal}
                    toggleModal={this.toggleTwoOhTwoModal}
                    confirm={this.handleReservationActivityClick}
                    abort={this.toggleTwoOhTwoModal}
                />
                
                <div className="page-header">
                    <div className="page-header-links">
                        {/* MVC-1114 Changes */}
                        {/* <MvLink label='Retrun to Search Criteria' onClick={this.handleReturnToSearchClick} /> */}
                        {[ReactAppMode.VOA, ReactAppMode.VCAP].includes(EXEC_MODE) && <MvLink label='Ownership Summary' onClick={this.handleOwnershipSummaryClick} />}
                        {[ReactAppMode.VOA, ReactAppMode.VCAP].includes(EXEC_MODE) && <MvLink label={screenType?"Waitlist Management ":'Reservation Activity'} onClick={this.handleReservationActivityClick} />}
                        {/* {[ReactAppMode.VCAP].includes(EXEC_MODE) &&
                        <MvLink label='Ownership Summary' onClick={this.handleOwnershipSummaryClick}/>
                        } */}
                        {/* {[ReactAppMode.VCAP].includes(EXEC_MODE) &&
                            <MvLink label='Reservation Activity' onClick={this.handleReservationActivityClick} />
                        } */}
                        {[ReactAppMode.VOA, ReactAppMode.VCAP].includes(EXEC_MODE) &&
                            <MvLink label='Book Another Reservation' onClick={this.handleBookYourHolidayClick} />
                        }
                    </div>

                    <div>
                        <h1>
                            {" "}
                            {localize(`${"Reservation"}: Confirmation`)}
                            {/* {localize("static.content.sc-confirm-header")} */}
                        </h1>
                        <button className='print-container' onClick={this.print}>
                            
                            <MvIcon
                                color="#5F5F5F"
                                style={{
                                    height: "14px",
                                    width: "14px"
                                }}
                                icon={"print"}
                            />
                            <p>{localize("Print")}</p>
                        </button>
                    </div>
                </div>
                {
                    screenType ? 
                        <div className="">
                            {!bookingInfo.twoOhTwoBookingError &&
                                <div className="details-label">
                                    {localize("Reservation #: ")}
                                    {/* {localize("static.content.sc-confirm-confirmation")}{":"} */}
                                    { bookingInfo.reservationConfirmationNumber}
                                </div>
                            }
                            <div className="details-label">
                                {localize("Transaction Date:")}
                                {/* {localize("static.content.sc-confirm-trans-date")}{":"} */}
                                {" "}
                                {moment(bookingInfo.transactionDate).format("D MMM YYYY")}
                            </div>
                        </div> :
                        <div className="details-container">
                            <div className="details-label">
                                {localize("Transaction Date:")}
                                {/* {localize("static.content.sc-confirm-trans-date")}{":"} */}
                                {" "}
                                {moment(bookingInfo.transactionDate).format("D MMM YYYY")}
                            </div>
                            {!bookingInfo.twoOhTwoBookingError &&
                            <div className="details-label">
                                {localize("Confirmation #: ")}
                                {/* {localize("static.content.sc-confirm-confirmation")}{":"} */}
                                {bookingInfo.reservationConfirmationNumber}
                            </div>
                            }
                        </div>
                    }
                    { // TODO: NEED TO BE FIXED

                        (
                            <BookingInfo
                                reservationDetails={bookingInfo.summary.reservationDetails}
                                pointsRequired={bookingInfo.summary.reservationDetails.pointsRequired}
                                onEditSearchClick={()=>{}}
                                readOnly={true}
                                visitResortNewTab={true}
                                setScreenType={() => {}}
                            />
                        )
                    }
                
                <div className='border-container'>
                    <StayPreferences
                        selectedPreferences={this.state.selectedPreferences}
                        preferenceOptions={preferences}
                        updateStayPreferences={()=>{}}
                        optionsLoading={false}
                        readOnly={true}
                    />
                    <GuestProfile
                        guest={this.getPrimaryGuestInformation()}
                        readOnly={true}
                    />

                    <AdditionalGuestProfile
                        readonly={true}
                        additionalGuests={this.getAdditionalGuests()}
                        emails={this.getAdditionalEmails()}
                    />
                    
                    <UsageDetails
                        contracts={(this.props.appliedPointContracts !== null ? this.props.appliedPointContracts.filter(c => c.appliedPoints > 0) : [])}
                        contractToolTips={this.props.contractToolTips}
                        onContractsSort={this.props.handleContractsSort}
                        onEditClick={()=>{}}
                        readOnly={true}
                        tablesExpandable={false}
                        screenType={this.props.screenType}
                        apiTimeout = {this.props.apiTimeout}
                    />
                     <div className='summaryReviewTnC'>
                        <MvTermsConditions
                            heading={localize("static.content.sr-tnc-heading")}
                            subHeading={localize("static.content.sr-tnc-sub-heading")}
                            instructions={this.getTerms()}
                            onChange={() => {}}
                            submissionFailed={false}
                            readOnly={true}
                        />
                    </div>
                </div>
                <PromoSection
                    promos={this.state.ads.map(ad => ({
                        image: ad.image,
                        url: ad.url
                    }))}
                />
            </div>
        );
    }
}


Confirmation.contextType = LocalizationContext;

export default Confirmation;